import React from "react";
import Dashboard, {
  CmmsDataProvider,
  defaultCmmsDataProvider
} from "asset-metrics-dashboard";
import ReactDOM from "react-dom/client";
import "jsvectormap/dist/css/jsvectormap.css";
import 'react-toastify/dist/ReactToastify.css';
import 'react-modal-video/css/modal-video.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import App from "./App";
import reportWebVitals from "./reportWebVitals";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <>
    <App />
  </>
);

const loader = document.getElementById('startup-loader');
if (loader) {
  loader.style.display = 'none';
}

reportWebVitals();
